// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Delivery24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Delivery24CircleFilled: FC<Delivery24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-7.756-9.199a2.761 2.761 0 0 0 2.029.835c.795 0 1.471-.278 2.028-.835a2.761 2.761 0 0 0 .835-2.028h5.728c0 .795.278 1.471.835 2.028a2.761 2.761 0 0 0 2.028.835c.796 0 1.472-.278 2.029-.835a2.762 2.762 0 0 0 .835-2.028H26.5V16l-2.864-3.818h-2.863V8.364H7.409c-.525 0-.974.187-1.348.56-.374.374-.561.824-.561 1.349v10.5h1.91c0 .795.277 1.471.834 2.028Zm2.709-1.348a.923.923 0 0 1-.68.274.924.924 0 0 1-.68-.274.923.923 0 0 1-.275-.68c0-.27.092-.497.275-.68a.924.924 0 0 1 .68-.275c.27 0 .497.092.68.275.183.183.274.41.274.68 0 .27-.091.497-.274.68Zm11.454 0a.924.924 0 0 1-.68.274.923.923 0 0 1-.68-.274.923.923 0 0 1-.274-.68c0-.27.091-.497.274-.68a.924.924 0 0 1 .68-.275c.27 0 .497.092.68.275.183.183.275.41.275.68 0 .27-.092.497-.275.68Zm2.422-4.498h-4.056V14.09h1.909l2.148 2.864Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Delivery24CircleFilled;
